import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { pageUp, pageDown, currentPage } from '../../../Redux/Slices/generalSlice';
import { setLanguageEnglish, setLanguageUrdu, currentLanguage } from '../../../Redux/Slices/languageSlice';
import { EP3_quest1Data, EP3_quest1Selected } from '../../../Redux/Slices/selectedOptionSlice';
import './F57.css';
import backIcon2 from '../../../Assests/backIcon2.svg'

function Frame57() {
    let dispatch = useDispatch();
    let pageNo = useSelector(currentPage);
    let language = useSelector(currentLanguage);
    let quest1 = useSelector(EP3_quest1Data);

        return (
            <div className="F57_imageAnimate">
                <img onClick={() => { dispatch(pageDown()) }} className='backButton' src={backIcon2} alt="React Logo" height={30} />
                <div className="F57_entryBox">
                    <div className="F57_heading">
                        {
                            language === 'english' ?
                                <p className="F57_headingEnglish">One of the girls tells Saira that it’s shameful to have a Sanitary Station in school. How should Saira respond to this?</p>
                                :
                                <p className="F57_headingUrdu">لیکن ان میں سے ایک لڑکی کہتی ہے کہ سکول میں سینیٹری سٹیشن کا ہونا باعث شرم ہے۔ آپ کے خیال میں سائرا کو اس کا کیا جواب دینا چاہیے؟ </p>
                        }
                    </div>
                    <div className="F57_options">
                        <div onClick={() => { dispatch(EP3_quest1Selected('A'), dispatch(pageUp())) }} className={language === 'english' ? "F57_option" : "F57_optionUrdu"}>
                            {language === 'english' ? `A. ${quest1.headingEnglish.A}` : `${quest1.headingUrdu.A}`}
                        </div>

                        <div onClick={() => { dispatch(EP3_quest1Selected('B'), dispatch(pageUp())) }} className={language === 'english' ? "F57_option" : "F57_optionUrdu"}>
                            {language === 'english' ? `B. ${quest1.headingEnglish.B}` : `${quest1.headingUrdu.B}`}
                        </div>
                        
                    </div>

                    <div className="F57_timeline">
                        <div className='F57_timelineBar'>
                            <div className='F57_timelineFill'></div>
                            <span className='F57_timelineText'>7/14</span>
                        </div>
                    </div>

                    <div className="F57_nextFrames">
                        <div className="F57_nextFrame1"></div>
                        <div className="F57_nextFrame2"></div>
                        <div className="F57_nextFrame3"></div>
                    </div>

                </div>
            </div>
        )
}

export default Frame57;